import React, { useEffect, useState } from 'react';

const OrderSummary = ({ items = [], totals = {}, children }) => {
  const [displayTotals, setDisplayTotals] = useState(totals);

  // Safe formatting function with fallbacks
  const safeFormat = (value) => {
    if (value === undefined || value === null) {
      return "0.00";
    }
    
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (typeof num !== 'number' || isNaN(num)) {
      return "0.00";
    }
    
    try {
      return num.toFixed(2);
    } catch (e) {
      return "0.00";
    }
  };

  useEffect(() => {
    setDisplayTotals(totals);
  }, [totals]);

  // Default empty values
  const defaultTotals = {
    subtotalHT: 0,
    remise: 0,
    tva: 0,
    deliveryFee: 0,
    total: 0
  };

  // Use the totals from props (which include promo discount calculation)
  const finalDisplayTotals = { ...defaultTotals, ...displayTotals };
  
  // Guard against empty item array
  const itemCount = Array.isArray(items) ? items.length : 0;

  return (
    <div className="bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden">
      
      <div className="bg-white py-5 px-6">
        {/* Status selector is rendered here if passed as children */}
        {children && (
          <div className="mb-5 pb-5 border-b border-gray-100">
            {children}
          </div>
        )}
        
        {/* Order item count summary */}
        <div className="flex justify-between pb-4 mb-4 border-b border-gray-100">
          <span className="text-sm text-gray-500">Articles</span>
          <span className="text-sm font-medium text-gray-900">
            {itemCount} article{itemCount !== 1 ? 's' : ''}
          </span>
        </div>
        
        {/* Sous-total HT (before remise) */}
        <div className="flex justify-between py-2">
          <span className="text-sm text-gray-500">Sous-total HT</span>
          <span className="text-sm font-medium text-gray-900">
            {safeFormat(finalDisplayTotals.subtotalHT)} TND
          </span>
        </div>

        {/* Display total discount/remise - INCLUDES PROMO DISCOUNT */}
        {finalDisplayTotals.remise > 0 && (
          <div className="flex justify-between py-2">
            <span className="text-sm text-gray-500">
              Remise
              {finalDisplayTotals.promoDiscount > 0 && (
                <span className="text-green-600 ml-1">
                  (dont {safeFormat(finalDisplayTotals.promoDiscount)} TND de code promo)
                </span>
              )}
            </span>
            <span className="text-sm font-medium text-red-600">
              -{safeFormat(finalDisplayTotals.remise)} TND
            </span>
          </div>
        )}
        
        {/* TVA total */}
        <div className="flex justify-between py-2">
          <span className="text-sm text-gray-500">TVA</span>
          <span className="text-sm font-medium text-gray-900">
            {safeFormat(finalDisplayTotals.tva)} TND
          </span>
        </div>
        
        {/* Delivery fee if applicable */}
        <div className="flex justify-between py-2">
          <span className="text-sm text-gray-500">Frais de livraison</span>
          <span className="text-sm font-medium text-gray-900">
            {safeFormat(finalDisplayTotals.deliveryFee)} TND
          </span>
        </div>
        
        {/* Order total - THIS WILL NOW SHOW THE CORRECT TOTAL WITH PROMO DISCOUNT */}
        <div className="flex justify-between pt-4 mt-4 border-t border-gray-200">
          <span className="text-base font-medium text-gray-900">Total TTC</span>
          <span className="text-base font-bold text-gray-900">
            {safeFormat(finalDisplayTotals.total)} TND
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;